import { render, staticRenderFns } from "./AlternativeAudio.vue?vue&type=template&id=20413cd2&"
import script from "./AlternativeAudio.vue?vue&type=script&lang=js&"
export * from "./AlternativeAudio.vue?vue&type=script&lang=js&"
import style0 from "./AlternativeAudio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports